import * as React from "react";
import classnames from "classnames";
import { Price } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/iris-ui";
/* empty css                                                     */
const PriceRow = ({
  label,
  price,
  currency,
  isDiscount = false,
  isEmphasized = false
}) => /* @__PURE__ */ React.createElement("div", { role: "listitem", className: "price-row" }, /* @__PURE__ */ React.createElement(
  Text,
  {
    className: classnames("price-row__label", { "price-row__label--emphasized": isEmphasized }),
    component: "span"
  },
  label
), /* @__PURE__ */ React.createElement(
  Price,
  {
    value: price,
    currency,
    className: classnames("price-row__price", { "price-row__price--emphasized": isEmphasized }),
    type: isDiscount ? "discount" : "default"
  }
));
export {
  PriceRow
};
//# sourceMappingURL=PriceRow.js.map
